<template>
  <b-container fluid>
    <b-card
      border-variant="danger"
      :header="$t('EditFilterTag.header')"
      header-bg-variant="danger"
      header-text-variant="white"
      align="left"
    >
      <div>
        <b-tabs content-class="mt-3" v-model="tabIndex">
          <b-tab v-for="(lang, i) in langOptions" :key="i">
            <template v-slot:title>
              <country-flag :country="getLocale(lang)" size="normal" />
            </template>
          </b-tab>
        </b-tabs>
      </div>

      <div>
        <div v-for="(n, i) in form.name" :key="i">
          <b-row align-v="center" v-if="n.lang === selectedLanguage">
            <b-col>
              <b-form-group :label="$t('EditFilterTag.name')">
                <b-form-input type="text" v-model="n.value" required></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
        </div>
      </div>

      <b-row class="mt-3 justify-content-center">
        <b-col>
          <b-button
            variant="secondary"
            type="submit"
            class="float-right"
            @click="$router.push({name: 'EditFilterTags'})"
          >{{ $t('EditFilterTag.cancel') }}</b-button>
        </b-col>
        <b-col>
          <b-button
            variant="danger"
            type="submit"
            @click="checkFieldsAndSave"
          >{{ $t('EditFilterTag.save') }}</b-button>
        </b-col>
      </b-row>
      <b-row class="mt-3 justify-content-center">
        <b-alert :show="error.received" variant="danger" class="text-center">{{error.msg}}</b-alert>
      </b-row>
      <b-row v-if="error.showLink" class="justify-content-center">
        <router-link :to="{name: 'EditFilterTags'}">{{ $t('EditFilterTag.editFilterTagsPageLink') }}</router-link>
      </b-row>
    </b-card>
  </b-container>
</template>

<script>
/* CONTROLLER */
import locales from '../i18n/locales'
import FilterTagsService from '@/services/FilterTagsService'
import HelperFunctions from '@/extras/HelperFunctions'
import { mapGetters } from 'vuex'

export default {
  name: 'EditFilterTag',
  data () {
    return {
      error: {
        received: false,
        msg: '',
        showLink: false
      },
      form: {
        _id: null,
        name: []
      },
      langOptions: [],
      selectedLanguage: this.$i18n.locale,
      tabIndex: 0
    }
  },
  mounted () {
    // redirect if user not logged in
    let smartdineLocalStorage = JSON.parse(
      window.localStorage.getItem('smartdine')
    )
    if (!smartdineLocalStorage.token) this.$router.push({ name: 'Login' })
    // if currentFilterTag not in state, redirect back to EditFilterTags
    else if (!this.currentFilterTag) this.$router.push({ name: 'EditFilterTags' })
    // if all good, get language options and prefill name
    else {
      this.languageOptions()
      this.selectedLanguage = this.langOptions[this.tabIndex].value
      this.prefillName()
    }
  },
  methods: {
    async prefillName () {
      // Prefill form
      this.form._id = this.currentFilterTag._id
      this.form.name = this.buildNameFields(this.currentFilterTag.name)
    },
    buildNameFields (name) {
      // this function is needed to populate title fields for all languages
      let nameLangs = []
      name.forEach(n => {
        nameLangs.push(n.lang)
      })

      // add name objects for all non-existing languages
      this.langOptions.forEach(l => {
        if (!nameLangs.includes(l.value)) {
          name.push({ lang: l.value, value: null })
        }
      })

      return name
    },
    checkFieldsAndSave () {
      // take out any null lang/value objects
      if (!HelperFunctions.areAllValuesNullEmpty(this.form.name)) {
        this.form.name = this.filterNulls(this.form.name)
        this.saveFilterName()
      } else {
        this.error.received = true
        this.error.showLink = true
        this.error.msg = this.$i18n.t('EditFilterTag.declareName')
      }
    },
    async saveFilterName () {
      // filter out any null titles
      let name = this.form.name.filter(n => {
        return n.value !== null
      })
      const updateName = {
        _id: this.form._id,
        name: name
      }
      try {
        // update filtertag in DB
        const response = await FilterTagsService.updateFilterTag(updateName)
        this.toEditFilterTags(response.data.filtertag)
      } catch (error) {
        this.error.received = true
        this.error.showLink = true
        this.error.msg = error.response.data.error
      }
    },
    toEditFilterTags (ft) {
      // set currentItem state
      this.$store.dispatch('setCurrentFilterTag', ft)

      // navigate to edit item panel
      this.$router.push({ name: 'EditFilterTags' })
    },
    languageOptions () {
      // get languages from i18n and assign value/text to langOptions
      this.langOptions = Object.keys(this.$i18n.messages).map(l => {
        return { value: l, text: l.toUpperCase() }
      })
    },
    filterNulls (obj) {
      return obj.filter(el => {
        return el.value !== null && el.value !== ''
      })
    },
    getLocale (lang) {
      return locales.filter(l => l.code === lang.value)[0].flag
    }
  },
  computed: {
    ...mapGetters({ currentFilterTag: 'currentFilterTag' })
  },
  watch: {
    tabIndex () {
      if (this.tabIndex !== -1) {
        this.selectedLanguage = this.langOptions[this.tabIndex].value
      }
    }
  }
}
</script>

<style scoped>
.btn {
  margin: 0.1em 0.25em 0.1em 0.25em;
}

.modal-dialog h3 {
  color: #0d47a1;
}
.badge {
  line-height: 1.5em;
}
</style>



// WEBPACK FOOTER //
// src/components/EditFilterTag.vue